import GenericTable from "@/components/ui/GenericTable";

interface Props {
  data: any[];
}

export default function PaymentPendingUserTable({
  data,
}: Props) {
  const columns = [
    {
      key: "Username",
      label: "User",
      render: (value: string) => (
        <div className="font-semibold">
          {value}
        </div>
      ),
    },

    {
      key: "Total_Price",
      label: "Total Price",
      render: (value: number) => (
        <span className="font-bold text-green-600">
          ₹{Number(value).toLocaleString()}
        </span>
      ),
    },

    {
      key: "Child",
      label: "Children",
      render: (children: any[]) => (
        <div className="space-y-3 min-w-[700px]">

          {children?.map(
            (child: any, index: number) => (
              <div
                key={index}
                className="border rounded-xl p-4 bg-gray-50"
              >
                <div className="grid grid-cols-8 gap-4">

                  <div>
                    <p className="text-xs text-gray-500">
                      Child
                    </p>

                    <p className="font-semibold">
                      {child.Child_Name}
                    </p>
                  </div>

                  <div>
                    <p className="text-xs text-gray-500">
                      Plan
                    </p>

                    <p>
                      {child.Plan_Name}
                    </p>
                  </div>

                  <div>
                    <p className="text-xs text-gray-500">
                      State
                    </p>

                    <p>
                      {child.State}
                    </p>
                  </div>

                  <div>
                    <p className="text-xs text-gray-500">
                      City
                    </p>

                    <p>
                      {child.City}
                    </p>
                  </div>

                  <div>
                    <p className="text-xs text-gray-500">
                      Distance
                    </p>

                    <p>
                      {child.Lal_Lon_Km} KM
                    </p>
                  </div>

                  <div>
                    <p className="text-xs text-gray-500">
                      Period
                    </p>

                    <p>
                      {child.Range?.Period}
                    </p>
                  </div>

                  <div>
                    <p className="text-xs text-gray-500">
                      Base
                    </p>

                    <p>
                      ₹
                      {Number(
                        child.Range
                          ?.Base_Price
                      ).toLocaleString()}
                    </p>
                  </div>

                  <div>
                    <p className="text-xs text-gray-500">
                      Final
                    </p>

                    <p className="font-bold text-brand-600">
                      ₹
                      {Number(
                        child.Range
                          ?.Final_Amount
                      ).toLocaleString()}
                    </p>
                  </div>

                </div>

                <div className="mt-3 flex gap-6 text-sm">

                  <span>
                    KM:
                    {" "}
                    {
                      child.Range
                        ?.KM_Range
                    }
                  </span>

                  <span>
                    Discount:
                    {" "}
                    {
                      child.Range
                        ?.Discount_Percentage
                    }
                    %
                  </span>

                  <span>
                    Saved:
                    ₹
                    {
                      child.Range
                        ?.Discount_Amount
                    }
                  </span>

                </div>
              </div>
            )
          )}

        </div>
      ),
    },
  ];

  return (
    <GenericTable
      title="User Subscription Summary"
      columns={columns}
      data={data}
      loading={false}
      emptyMessage="No Records Found"
    />
  );
}